import { jsx as _jsx } from "react/jsx-runtime";
import React, { forwardRef, useImperativeHandle, useMemo, useRef } from 'react';
import { getTestIds } from '../../utils/TestIds';
import { useDevice } from '../Device';
import { EditableTableListDesktop } from './EditableTableListDesktop';
import { EditableTableListMobile } from './EditableTableListMobile';
import { useEditableTableListDnd } from './hooks/useEditableTableListDnd';
export const GetEditableTableListTID = (parentTestId)=>getTestIds(parentTestId);
function EditableTableListInner(param, ref) {
    let { rows, columns, getRowId, isRowStatic, disabledRowTooltip, onRemoveRow, onReorder, renderRowFooter, editSheetHeader, renderEditSheetFooter, renderEditSheet, bi, testId } = param;
    const { EditableTableListTestIds } = useMemo(()=>GetEditableTableListTID(testId), [
        testId
    ]);
    const { isMobileDevice } = useDevice();
    const dnd = useEditableTableListDnd({
        rows,
        getRowId,
        isRowStatic,
        onReorder
    });
    const mobileRef = useRef(null);
    useImperativeHandle(ref, ()=>({
            openEditRow: (rowId)=>{
                var _mobileRef_current;
                return (_mobileRef_current = mobileRef.current) === null || _mobileRef_current === void 0 ? void 0 : _mobileRef_current.openEditRow(rowId);
            }
        }));
    if (isMobileDevice) {
        return /*#__PURE__*/ _jsx(EditableTableListMobile, {
            ref: mobileRef,
            rows: rows,
            columns: columns,
            getRowId: getRowId,
            disabledRowTooltip: disabledRowTooltip,
            onRemoveRow: onRemoveRow,
            renderRowFooter: renderRowFooter,
            editSheetHeader: editSheetHeader,
            renderEditSheetFooter: renderEditSheetFooter,
            renderEditSheet: renderEditSheet,
            bi: bi,
            testIds: EditableTableListTestIds,
            dnd: dnd
        });
    }
    return /*#__PURE__*/ _jsx(EditableTableListDesktop, {
        rows: rows,
        columns: columns,
        onRemoveRow: onRemoveRow,
        renderRowFooter: renderRowFooter,
        bi: bi,
        testIds: EditableTableListTestIds,
        dnd: dnd
    });
}
export const EditableTableList = /*#__PURE__*/ forwardRef(EditableTableListInner);
